// src/components/ImageWithPlaceholder.jsx

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

/**
 * ImageWithPlaceholder Component
 * Displays a placeholder until the image is loaded.
 *
 * Props:
 * - src (string): The source URL of the image.
 * - alt (string): The alt text for the image.
 * - placeholder (React element): The placeholder component to display while loading.
 * - className (string): Additional CSS classes for the image.
 * - style (object): Inline styles for the image.
 * - ...props: Any other props to pass to the img element.
 */
const ImageWithPlaceholder = ({
  src,
  alt,
  placeholder,
  className = "",
  style = {},
  ...props
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleLoad = () => {
    setIsLoaded(true);
  };
  useEffect(() => {
    const image = new Image();
    image.src = src;
    image.onload = () => {
      setIsLoaded(true);
      //print("Image loaded");
    };
    image.onerror = () => {
      setHasError(true);
    };
    // Cleanup and
  }, [isLoaded]);
  if (!isLoaded) return placeholder;

  if (isLoaded)
    return (
      <img
        src={src}
        alt={alt}
        onLoad={handleLoad}
        style={{
          display: isLoaded ? "block" : "none",
        }}
        className={`image-with-placeholder ${className}`}
        {...props}
      />
    );
};

ImageWithPlaceholder.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  placeholder: PropTypes.element.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default ImageWithPlaceholder;
